import {
    CameraBrandModel,
    CameraModel,
    ControlModel,
    ControlTypeModel,
    GlassControlParameters,
    InputModel,
    InputTypeModel,
    MediaModel,
    CallListModel,
    SensorTypeModel,
    UserModel
} from "../../types/control"
import {BridgeDeviceModel} from "../../types/bridge-device"
import {IntercomModel} from "../../types/intercom"
import {DoorModel} from "../../types/door"
import {GatewayModel} from "../../types/gateway"
import {DoorBrandModel} from "../../types/door-brand"
import {BridgeDeviceTypeModel} from "../../types/bridge-device-type"
import {AlarmConfigModel} from "../../types/alarm-config"
import {LocationModel} from "../../types/location"
import {ConciergeModel} from "../../types/concierge"
import {ConciergeTypeModel} from "../../types/concierge-type"
import {RgbColor} from "../../components/ColorPicker/types"
import {SupervisorConfigModel} from "../../types/supervisor-config"
import {WorkerConfigModel} from "../../types/worker-config"
import {LucentConfigModel} from "../../types/lucent-config"

export const initialControlState: ControlState = {
    controlTypeList: [],
    userList: [],
    controlList: [],
    groupControlList: [],
    scenarioList: [],
    scenarioTriggerList: [],
    bridgeDeviceList: [],
    bridgeDeviceTypeList: [],
    gatewayList: [],
    cameraList: [],
    cameraBrandList: [],
    inputList: [],
    inputTypeList: [],
    sensorTypeList: [],
    areaList: [],
    mediaList: [],
    mediaInputList: [],
    virtualControlList: [],
    mediaStatus: "closed",
    intercomState: {
        status: "ended",
        info: null,
        is_incoming_call: true,
        id: "",
        name: "",
        call_time: 0
    },
    bellStatus: "ended",
    doorList: [],
    doorBrandList: [],
    intercomList: [],
    alarmState: {
        default: {
            level: 0,
            ringing: false,
            will_ring: false,
            latest_log_list: []
        }
    },
    sound: {
        intercom_level: 0,
        incoming_call_flat_front_level: 0,
        incoming_call_outside_panel_level: 0,
        alarm_level: 0,
        microphone_level: 0,
        click_sound: false
    },
    config: {
        alarm: {
            first_level_alarm_countdown_duration: 0,
            second_level_alarm_countdown_duration: 0,
            third_level_alarm_countdown_duration: 0,
            reactivation_duration_after_reset: 0,
            siren_interval_on_duration: 0,
            siren_interval_off_duration: 0,
            siren_interval_repeat_count: 0
        },
        lucent_config: {
            is_sleep_mode_active: false,
            sleep_time: 0,
            sensitivity_mode: "0",
            sensitivity_right_touch: "0",
            sensitivity_left_touch: "0"
        },
        alarm_settings: {
            home_timer_seconds: 0,
            outside_timer_seconds: 0
        },
        location: null,
        location_v2: null,
        language: "tr",
        indicator_status: false,
        advanced_authorization_status: false
    },
    homepageItemList: [],
    locationList: [],
    menuList: [],
    stpUIList: [],
    languageList: [],
    conciergeList: [],
    conciergeTypeList: [],
    screenSaverStatus: "",
    iftttList: {
        e_mail: "email",
        password: "password",
        token: "token",
        is_enabled: true
    },
    passwordStatus: null,
    passwordStatusV2: null,
    versionStatus: null,
    screenStateList: {
        screen_saver_active_brightness: 10,
        screen_saver_status: true,
        screen_saver_timing_minute: 5,
        screen_saver_type: "digital-clock",
        screen_sleep_second: 5,
        screen_standard_brightness: 70,
        screen_lock_status: false,
        screen_lock_timing_minute: 5,
        send_notification: false
    },
    logList: [],
    userLogList: [],
    connectionIcons: {
        check_time: null,
        cloud: "",
        ethernet: "",
        sip: "",
        wifi_level: ""
    },
    rssiStatus: null,
    readAllTempFunc: null,
    supConfigList: null,
    workerConfig: null,
    projectInformationList: [],
    energyState: {
        currency_unit: "",
        device_pulse_kwh: "",
        energy_fee: "",
        max_point: "",
        energy_fee_v2: "",
        energy_fee_v3: "",
        start_time_for_energy_fee: "",
        start_time_for_energy_fee_v2: "",
        start_time_for_energy_fee_v3: ""
    },
    energyInfo: [],
    energyUpdated: {
        control_id: null,
        energy_value: null
    },
    messageList: {
        questionsAnwsers: [],
        announcement: [],
        unread: null
    },
    messageStatus: null,
    messageNotification: null,
    userResetPassword: {
        user_name: "",
        current_password: "",
        new_password: "",
        auth_code: "",
        alarm_password: "",
        first_login: false
    },
    callListList: [],
    soundPlayingStatus: {
        command: "",
        name: 0,
        play_status: true,
        sound_level: 0,
        mic_level: 0,
        sound_list: []
    },
    callTime: null,
    callLogListList: [],
    touchMessageStatus: {
        message: true
    },
    pingTest: "",
    traceRouteTest: "",
    mousePointerStatus: false,
    authorityGroupList: [],
    favoritesPage: false,
    temporaryUserStatus: "",
    matchState: "",
    externalUsbStatus: false,
    timezoneList: [],
    timezoneOffset: {
        timezone: "",
        timezone_offset_in_minutes: 0,
        is_manual_time_offset: false
    },
    alarmTimer: {
        alarm_level: 0,
        timer_is_running: false,
        timer_seconds: null
    },
    callBlockList: [],
    boosterList: [],
    sipFormatTypeList: [],
    suntime: {
        name: "",
        sunrise: "",
        sunset: ""
    },
    somResetCountdown: '',
    detailedRFTestResponse: null,
    frameUIList: []
}

export type SIPFormatType = {
    id?: string
    name: string
    format: string
    format_lenght: number
}

export type TempLogType = {
    measured: TempLogMeasured[]
    set: TempLogSet[]
}

export type NotificationLogType = {
    id: number
    message: string
    mobile_os: string
    timestamp: number
    username: string
}

export type TempLogExtended = {
    control_id: string
    analysis: string
}
export type TempLogMeasured = {
    average: number
    time_interval: string
}
export type TempLogSet = {
    mod: number
    time_interval: string
}

export type SunTimeType = {
    name:string
    sunset:string
    sunrise:string
}

export interface AuthorityParametersModel {
    after_time?: string
    before_time?: string
    can_disable_alarm: boolean
    day_list: number[]
    is_notification: boolean
    max_temp?: string
    min_temp?: string
}

export interface BoosterModel {
    id?: string
    booster_id: string
    boosted_device_id: string
}

export type AuthorityAccessList = {
    executable?: string[]
    viewable?: string[]
}
export interface AuthorityModel {
    id?: string
    name: string
    control_id_list: AuthorityAccessList
    user_id_list?: string[]
    camera_list: string[]
    area_list: AuthorityAccessList
    menu_list: string[]
    parameters: AuthorityParametersModel
}
export type AuthorityOverviewAccessList = {
    executable: AuthorityOverviewTypes[]
    viewable: AuthorityOverviewTypes[]
}
export type AuthorityOverviewTypes = {
    area_id: string
    id: string
    name: string
    type: string
}
export interface AuthorityOverviewModel {
    authority_group_name: string
    camera_list: string[]
    control_list: AuthorityOverviewAccessList
    menu_list: string[]
    parameters: AuthorityParametersModel
}

export type AuthorityOverviewList = {
    [key in string]: AuthorityOverviewModel
}

export type DateState = {
    timezone: string
    timezone_offset_in_minutes: number
    is_manual_time_offset: boolean
}
export type TimezoneType = {
    id: string
    name: string
    timezone: string
}

export type AlarmLogs = {
    icon_type: string
    id: number
    input_id: string
    message: string
    sensor_type_id: string
    timestamp: number
}

export type AsyncAlarmState = {
    alarm_level: number
    timer_is_running: boolean
    timer_seconds: number
}

export type SIPBlockedNumbersState = {
    id: string
    blocked_count: number
    number: string
    sip_number: string
    name: string
}

export type IntercomState = {
    status: string // todo enum
    info: IntercomModel
    is_incoming_call: boolean
    id: string
    name: string
    call_time?: number
}

export type AlarmLogModel = {
    timestamp: number
    log_message: string
    sensor_type_id: string
}

export type AlarmStateModel = {
    level: number // todo enum
    ringing: boolean
    will_ring: boolean
    latest_log_list: AlarmLogModel[]
}

export type AlarmState = {
    default: AlarmStateModel
}

export type FancoilScenario = {
    power_status?: boolean
    fan_speed?: string
    mode?: boolean
}
export type VRFScenario = {
    power_status?: string
    fan_speed?: string
    mode?: string
}
export type ScenarioOperationModel = {
    type: string
    relational_id: string
    rgb_color: RgbColor
    value: number
    delay_seconds: number
    fan_coil: FancoilScenario
    vrf: VRFScenario
}

export type UserResetPassword = {
    auth_code?: string
    first_login?: boolean
    user_name?: string
    current_password?: string
    new_password?: string
    alarm_password?: string
}

export type SoundPlayingStatus = {
    name: number
    command: string
    play_status: boolean
    sound_level?: number
    mic_level?: number
    sound_list?: string[]
}

export type ScenarioModel = {
    id: string
    name: string
    operation_list: ScenarioOperationModel[]
    is_playing?: boolean
    show_on_footer?: boolean
    is_notification?: boolean
    ifttt_trigger_name?: string
    icon_type?: string
    is_reversible?: boolean
    should_reverse_from_toggle_input?: boolean
    can_not_be_nested?: boolean
    parent_scenario_id?: string
}

export type ScenarioTriggerModel = {
    id: string
    name: string
    scenario_id: string
    is_passive?: boolean
    skip_count?: number
    settings: TimeTriggerSettingsModel
    is_reverse_trigger: boolean
}

export type SortingItemType = "control" | "sensor" | "homepage"

export type SortingItemModel = {
    is_auto_sorting?: boolean
    type?: SortingItemType
    relational_id?: string
    order?: number
}

export type TimeTriggerType = "exact" | "sunrise" | "sunset"

export type TimeTriggerSettingsModel = {
    day_list: number[]
    type: TimeTriggerType
    delay_in_seconds: number
    is_advanced: boolean
    adv_day_list: TriggerDayList[]
}

export type TriggerDayList = {
    days: number[]
}

export type CreateMediaDeviceModel = {
    name: string
    type: string
    bridge_device_id: string
    area_id?: string
}

export type AreaModel = {
    id: string
    name: string
    type: "place" | "floor" | "room"
    icon_type: string
    parent_area_id: string
}
export type AlarmSettingsModel = {
    home_timer_seconds: number
    outside_timer_seconds: number
}

export type ConfigModel = {
    id?: never
    alarm: AlarmConfigModel
    alarm_settings: AlarmSettingsModel
    lucent_config: LucentConfigModel
    location: LocationModel
    location_v2?: LocationModel
    language: string
    indicator_status: boolean
    advanced_authorization_status: boolean
}

export type MediaInputModel = {
    id: string
    slot: number
    name: string
    bridge_device_id: string
    control_id: string
    value: number
}

export type VirtualControlModel = {
    id: string
    slot: number
    bridge_device_id: string
    control_id: string
    registered_by_system?: boolean
    parameters: Omit<GlassControlParameters, "output_number">
}

export type HomepageItemType = "control" | "scenario" | "sensor" | "media"

export type HomepageItemModel = {
    id: string
    type: HomepageItemType
    relational_id: string
    order: number
}

export type SoundState = {
    intercom_level: number
    incoming_call_flat_front_level: number
    incoming_call_outside_panel_level: number
    alarm_level: number
    microphone_level: number
    click_sound: boolean
}

export type IftttState = {
    e_mail: string
    password: string
    token: string
    is_enabled: boolean
}

export type ScreenState = {
    screen_saver_active_brightness: number
    screen_standard_brightness: number
    screen_saver_timing_minute: number
    screen_sleep_second: number
    screen_saver_type: string
    screen_saver_status: boolean
    screen_lock_status: boolean
    screen_lock_timing_minute: number
    send_notification?: boolean
}

export type ProjectInfoDetails = {
    id?: string
    technician_name?: string
    time_span?: number
    project_explanation?: string
}
export type ProjectInfoList = {
    id?: string
    project_name?: string
    project_number?: string
    floor_apartment?: string
    dealer_no?: string
    country?: string
    project_explanation_list?: ProjectInfoDetails[]
}
export type ProjectInfo = {
    id?: string
    project_name?: string
    project_number?: string
    floor_apartment?: string
    dealer_no?: string
    country?: string
    technician_name?: string
    time_span?: number
    project_explanation?: string
}

export type EnergyAnalyzerModel = {
    currency_unit: string
    device_pulse_kwh: string
    max_point?: string
    energy_fee: string
    energy_fee_v2: string
    energy_fee_v3: string
    start_time_for_energy_fee: string
    start_time_for_energy_fee_v2: string
    start_time_for_energy_fee_v3: string
}

export type EnergyModel = {
    bridge_device_id: string
    control_id: string
    id: number
    time: number
    value: number
    price: number
} & EnergyModelTotal

export type EnergyModelTotal = {
    day: number
    date: string
    month: string
    total: number
}

export type EnergyMonitor = {
    control_id: string
    energy_value: string
}

export type UpdateFCMPushTokenRequest = {
    os: string
    token: string
}

export type MenuContentType = "control" | "media"

export type MenuContent = {
    type: MenuContentType
    relational_id: string
    order: number
}

export type LogListType = {
    id?: string
    name: string
}

export type SecurityCodeType = {
    session_countdown: number
    security_code: string
}

export type UserLogListType = {
    id: string
    username: string
    ip_address: string
    timestamp: any
}
export type AnswerMessage = {
    messageId: string
    answer: string
    blok?: string
    apartment?: string
}
export type MessageList = {
    messageId?: string
    apartment?: string
    blok?: string
    messageContent?: string
    messageStatus?: string
    messageTitle?: string
    messageType?: string
    messageDate?: string
    userAnswer?: string
}

export type MessageNotification = {
    unread: string
}
export type MessageListType = {
    questionsAnwsers?: MessageList[]
    announcement?: MessageList[]
    unread?: number
}

export type ConnectionIcons = {
    check_time: number
    cloud?: string
    ethernet?: string
    sip?: string
    wifi_level?: string
}
export type IFTTTResponse = {
    success: boolean
}

export type MenuEntity = {
    id?: string
    name: string
    icon: string
    order: number
    content_list: MenuContent[]
    is_special: boolean
    is_hidden: boolean
    onClick?: (e?: any) => void
}

export type STPUIType = "group" | "control" | "virtualControl" | "weather" | "scenario" | "media" | "air"
export type STPUIExtrasType = {
    double_button: boolean
    reverse_operation_type?: string
}
export type STPUIEntity = {
    id: string
    type: STPUIType
    display_name: string
    bridge_device_id: string
    relational_id?: string
    page_number: number
    row_number: number
    extras: STPUIExtrasType
}


export interface DetailedRFTestModel {
    device_rf_address: string
    related_gateway: string
    number_of_packet: string
    repeat: string
    period: string
    halt_on_error: string
}

export interface DetailedRFTestResponse {
    send_cnt: string
    address: string
    rx_rssi: string
    tx_rssi: string
    receive_cnt: string
    hop_cnt: string
    time: string
    max_tx_rssi: string
    min_tx_rssi: string
    max_rx_rssi: string
    min_rx_rssi: string
    timeout: string
    buffer_timeout: string
    sequence: string
}

export type FrameUIType = "weather" | "scenario" | 'virtualControl' | 'control'
export type FrameUIExtrasType = {
    scenario_id?: number
    slot?: number
    name: string
}

export type FrameUIEntity = {
    id: string
    type: FrameUIType
    bridge_device_id: string
    relational_id?: string
    page_number: number
    is_animation_active: boolean,
    icon_color_type: string,
    extras: FrameUIExtrasType
}

export type ControlState = {
    controlTypeList: ControlTypeModel<unknown>[]
    userList: UserModel[]
    controlList: ControlModel[]
    groupControlList: ControlModel[]
    bridgeDeviceList: BridgeDeviceModel[]
    bridgeDeviceTypeList: BridgeDeviceTypeModel[]
    gatewayList: GatewayModel[]
    scenarioList: ScenarioModel[]
    scenarioTriggerList: ScenarioTriggerModel[]
    cameraList: CameraModel[]
    cameraBrandList: CameraBrandModel[]
    conciergeList: ConciergeModel[]
    conciergeTypeList: ConciergeTypeModel[]
    doorList: DoorModel[]
    doorBrandList: DoorBrandModel[]
    intercomList: IntercomModel[]
    inputList: InputModel[]
    inputTypeList: InputTypeModel[]
    sensorTypeList: SensorTypeModel[]
    areaList: AreaModel[]
    mediaList: MediaModel[]
    mediaInputList: MediaInputModel[]
    virtualControlList: VirtualControlModel[]
    homepageItemList: HomepageItemModel[]
    locationList: LocationModel[]
    mediaStatus: string // todo enum
    intercomState: IntercomState
    bellStatus: string // todo enum
    alarmState: AlarmState
    sound: SoundState
    config: ConfigModel
    menuList: MenuEntity[]
    stpUIList: STPUIEntity[]
    languageList: LanguageModel[]
    screenSaverStatus: string
    iftttList: IftttState
    passwordStatus: boolean
    passwordStatusV2: boolean
    versionStatus: string
    screenStateList: ScreenState
    logList: LogListType[]
    userLogList: UserLogListType[]
    messageList: MessageListType
    messageStatus: AnswerMessage
    rssiStatus: string
    readAllTempFunc: string
    supConfigList: SupervisorConfigModel
    workerConfig: WorkerConfigModel
    projectInformationList: ProjectInfoList[]
    energyState: EnergyAnalyzerModel
    energyInfo: EnergyModel[]
    energyUpdated: EnergyMonitor
    messageNotification: MessageNotification
    connectionIcons: ConnectionIcons
    userResetPassword: UserResetPassword
    callListList: CallListModel[]
    soundPlayingStatus: SoundPlayingStatus
    callLogListList: CallLogList[]
    callTime: number
    touchMessageStatus: {
        message: boolean
    }
    pingTest: string
    traceRouteTest: string
    matchState: string
    mousePointerStatus: boolean
    authorityGroupList: AuthorityModel[]
    favoritesPage: boolean
    temporaryUserStatus: string
    externalUsbStatus: boolean
    timezoneList: TimezoneType[]
    timezoneOffset: DateState
    alarmTimer: AsyncAlarmState
    callBlockList: SIPBlockedNumbersState[]
    boosterList: BoosterModel[]
    sipFormatTypeList: SIPFormatType[]
    suntime: SunTimeType
    somResetCountdown: string
    detailedRFTestResponse: DetailedRFTestResponse
    frameUIList: FrameUIEntity[]
}

export type SetLanguage = {
    selected_language: string
}

export type AnswerIntercomType = {
    response: string
    info: number
}

export type SystemInfoTest = {
    linux_version: string
    cpu_info: string
    cpu_usage: string
    cpu_temp: string
    disk_usage: string
    ram_info: string
    screen_resolution: string
    supply_voltage: string
    supply_voltage_3v: string
    hardware_version: string
    hardware_temp: string
    temp_sensor_value: string
}

export type CallLogList = {
    id: string
    caller: string
    call_status: string
    call_time: number | string
    door_status: string
    gateway_name: string
}

export type LanguageModel = {
    id: string
    name: string
    variables: Map<string, string>
    settings_variables: Map<string, string>
}
